import { render, staticRenderFns } from "./cardTemplateVip06.vue?vue&type=template&id=242deb24&scoped=true&"
import script from "./cardTemplateVip06.vue?vue&type=script&lang=js&"
export * from "./cardTemplateVip06.vue?vue&type=script&lang=js&"
import style0 from "./cardTemplateVip06.vue?vue&type=style&index=0&id=242deb24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242deb24",
  null
  
)

export default component.exports